import type { WebediaPlayer } from '@webedia-services/webedia-player';

import { getVendorsConsent } from 'common/consent/Didomi';

import type { PlayerCustomData } from 'website/module/player';
import {
  loadComscoreLib,
  quartileEventTracking
} from 'website/tracking/player/comscore.internals';
import { getCurrentCustomData } from 'website/tracking/player/utils';

const initComscore = async (
  webediaPlayer: WebediaPlayer,
  customData: PlayerCustomData
) => {
  const hasComscoreConsent = await getVendorsConsent(['77']);

  if (!hasComscoreConsent) {
    return false;
  }

  webediaPlayer.addEventListener('ready', loadComscoreLib);

  webediaPlayer.addEventListener('quartile', customEvent => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(webediaPlayer, customEvent, currentCustomData);
  });
  webediaPlayer.addEventListener('quartile-postroll', customEvent => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(webediaPlayer, customEvent, currentCustomData);
  });
};

export default initComscore;
